// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__20MBR","navLinks":"Contact_navLinks__Tjauw","circle":"Contact_circle__chH02","message":"Contact_message__6nyPH"};